import styled from 'styled-components';

export const ContentRoot = styled.div``;